import React, { FunctionComponent } from 'react';
import { Box } from '@mui/material';

import { getSpinnersToDisplay, SpinnerMessage } from '@paragon/task-spinner';

import { ErrorBoundary } from '../ErrorBoundary';
import { useAppSelector } from '../hooks';
import { Routes } from '../Routes';

export const Content: FunctionComponent = () => {
  const spinnerMessages = useAppSelector(getSpinnersToDisplay);

  return (
    <Box
      sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        bgcolor: 'canvas.main',
        overflow: 'auto',
        p: 3,
        minWidth: 0, // So the Typography noWrap works
      }}
    >
      {Array.from(spinnerMessages).map((text) => (
        <SpinnerMessage text={text} key={text} />
      ))}

      <ErrorBoundary>
        <Routes />
      </ErrorBoundary>
    </Box>
  );
};
